import React from 'react';

import { useAutocomplete } from '~/hooks/useAutocomplete';
import { extendedHeaderMapper } from '~/mappers/header/extendedHeaderMapper';
import { ExtendedHeaderBasic } from '~/mappers/header/models';
import { gtmService } from '~/services/gtm';

import { ExtendedGlobalHeader } from '../ExtendedGlobalHeader';

const HeaderWrap = ({
  extendedHeaderBasic,
}: {
  extendedHeaderBasic?: ExtendedHeaderBasic | null;
}) => {
  const { autocompleteState, getInputProps } = useAutocomplete();

  const extendedMapped = extendedHeaderMapper({
    extendedHeaderBasic,
  });

  return extendedMapped ? (
    <ExtendedGlobalHeader
      {...{
        ...extendedMapped,
        profile: undefined,
        search: extendedMapped.search
          ? {
              ...extendedMapped.search,
              autocomplete: { autocompleteState, getInputProps },
            }
          : undefined,
        onClickNavItem: (value) => gtmService.emitHeaderMenuClick(value),
      }}
    />
  ) : null;
};

export default HeaderWrap;
